import { EMPTY_OBJECT } from '../../../../constants/common'
import { useEmailAccountsContext } from '../../../../hooks'
import { getEmailAccountForCreate } from '../../Email.utils'

export function useEmailGetActiveAccountForCreate({
  withServiceAccount = false,
} = EMPTY_OBJECT) {
  const {
    accounts: activeAccounts,
    loading: loadingAccount,
    serviceAccount,
  } = useEmailAccountsContext()

  const activeAccountForCreate =
    getEmailAccountForCreate(activeAccounts) ??
    (withServiceAccount ? serviceAccount : null)

  return { activeAccountForCreate, loadingAccount }
}
